import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';

import parcel from '~/domain/parcel/route';

const DeletePage = lazy(() => import('./pages/delete'));
const EditPage = lazy(() => import('./pages/edit'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/shipping-providers',
    title: 'Dostavne službe',
    Component: IndexPage,
    children: [parcel, {
        path: 'add',
        Component: ModalOutlet,
        children: [{
            index: true,
            Component: EditPage,
        }]
    }, {
        path: ':providerId',
        Component: ModalOutlet,
        children: [{
            path: 'delete',
            Component: DeletePage,
        }, {
            path: 'edit',
            Component: EditPage,
        }]
    }],
} satisfies RouteObject;
